import React, { FC } from 'react'
import Moment from 'react-moment';
import { ArticleNode, GetSlug } from '../../utils/core';
import { GatsbyImage, GatsbyImageProps, IGatsbyImageData } from "gatsby-plugin-image"
import { Link, useI18next  } from "../../plugins/i18next/ea-react-i18next";


export const OtherArticles: FC<{  articles: ArticleNode[];  currentSlug: string; }> = ({ articles, currentSlug }) => {
  const { i18n } = useI18next();
  const currentLanguage = i18n.language;

  const filteredArticles = articles
    .filter((p) => {
      /*  
       //Use if Articles need to be filtered by current language 
      if ((p.node.frontmatter.slug !== currentSlug) && (currentLanguage === p.node.fields.language )) {
        return p;
      } */
      return p;
    })
    .slice(0, 3);

  return (
    <div className="widget widget_tracer_posts_thumb">
      <h3 className="widget-title">Other Articles</h3>
      {filteredArticles.map((article) => (
        <article className="item" key={article.id}>
          <Link
            to={GetSlug(article.frontmatter.category, article.frontmatter.slug)}
            className="thumb"
            key={`image${article.id}`}
          >
          { article.frontmatter.blogimage?.childImageSharp?.gatsbyImageData &&  <GatsbyImage
              image={article.frontmatter.blogimage?.childImageSharp?.gatsbyImageData as unknown as  IGatsbyImageData}
              className="fullimage cover bg1"
              alt={article.frontmatter.blogimage?.alternativeText ?? ""}
            />}
          </Link>
          <div className="info">
            <span><Moment format="L">{article.frontmatter.date}</Moment></span>
            <h4 className="title usmall">
              <Link to={GetSlug(article.frontmatter.category, article.frontmatter.slug)}>
                {article.frontmatter.title}
              </Link>
            </h4>
          </div>
          <div className="clear"></div>
        </article>
      ))}
    </div>
  );
}
